import { Component, HostBinding, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface RadLinkRendererBaseParams {
  linkText?: string;
  linkUrl?: string;
  tooltipText?: string;
  target?: '_blank' | '_self';
  columnWidthReduction?: number;
}

export interface RadLinkRendererParams extends ICellRendererParams, RadLinkRendererBaseParams {}

@Component({
  selector: 'app-rad-link-renderer',
  templateUrl: './rad-link-renderer.component.html',
  styleUrls: ['./rad-link-renderer.component.scss']
})
export class RadLinkRendererComponent implements OnInit, ICellRendererAngularComp {
  public params: RadLinkRendererParams;
  public linkText: string;
  public linkUrl: string;
  public tooltipText: string;
  public target: string = '_blank';
  public hasTooltip: boolean = false;
  public hasLink: boolean = false;
  public linkStyle: string;

  get tooltipPosition(): string {
    if(!this.params || this.params.node.rowIndex !== 0) {
      return 'top';
    } else {
      return 'right';
    }
  }

  @HostBinding('style.--column-width') 
  get columnWidth(): string {
    if(this.params) {
      const columnWidthReduction = this.params.columnWidthReduction ? this.params.columnWidthReduction : 40;
      return `${this.params.column.getActualWidth() - columnWidthReduction}px`;
    }
  }

  constructor() { }

  ngOnInit() {
    this.linkStyle = `
      .rad-btn--link-container {
        overflow: hidden;
        display: inline-block;
        vertical-align: middle;
        text-overflow: ellipsis;
        width: auto;
        max-width: var(--column-width, 80px);
      }
    `;
  }

  agInit(params: RadLinkRendererParams): void {
    this.params = params;
    
    // Set link text - use provided text or fallback
    this.linkText = params.linkText || '';
    this.linkUrl = params.linkUrl;
    this.hasLink = !!params.linkUrl
    
    // Set tooltip text if provided
    this.tooltipText = params.tooltipText;
    this.hasTooltip = !!this.tooltipText;
    
    // Set target
    this.target = params.target || '_blank';
  }

  refresh(params: RadLinkRendererParams): boolean {
    this.agInit(params);
    return true;
  }
}
